import { createAction, handleActions } from 'redux-actions';
import { Api } from "../../api/api";
import { fetchSubmitForm, fetchSubmitFormFailed, resetSubmitFormData } from '../common/submitForm';
import { logout, onForbidden } from '../account/login';
import _ from 'lodash';
import { hideModal } from "../common/activeModal";
import { fetchGetSubRoles } from '../account/role';
import { getUserId } from '../account/userData';

//- Actions
export const fetchGetStaffMembersFailed = createAction('FETCH_GET_STAFF_MEMBERS_FAILED');
export const fetchGetStaffMembersSuccess = createAction('FETCH_GET_STAFF_MEMBERS_SUCCESS');
export const onGetStaffMembersSuccess = (data) => (dispatch) => {
    let isEmpty = data.empty;
    let currentPage = data.number;
    if ((!isEmpty && currentPage !== 0) || currentPage === 0){
        dispatch(fetchGetStaffMembersSuccess(data));
    } else {        
        dispatch(fetchGetStaffMembers(currentPage - 1));
    }
};
export const fetchGetStaffMembers = createAction(
    'FETCH_GET_STAFF_MEMBERS',
    (page, size) => Api.getStaffMembers(page, size),
    () => ({
        apiCall: true,
        onSuccess: onGetStaffMembersSuccess,
        onFail: fetchGetStaffMembersFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetAllStaffMembersFailed = createAction('FETCH_GET_ALL_STAFF_MEMBERS_FAILED');
export const fetchGetAllStaffMembersSuccess = createAction('FETCH_GET_ALL_STAFF_MEMBERS_SUCCESS');
// TODO: remove hardcoded values, add correct request for all active employees
export const fetchGetAllStaffMembers = createAction(
    'FETCH_GET_ALL_STAFF_MEMBERS',
    () => Api.getStaffMembers(0, 500),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAllStaffMembersSuccess,
        onFail: fetchGetAllStaffMembersFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onGetStaffMembersForCurrentPage = () => (dispatch, getState) => {
    let currentPage = getCurrentPageForStaff(getState());
    dispatch(fetchGetStaffMembers(currentPage));
};

export const fetchRegisterStaffMember = (data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onRegisterStaffMember(data));
};
export const onRegisterStaffMemberSuccess = () => dispatch => {
    dispatch(resetSubmitFormData());
    dispatch(hideModal());
    dispatch(onGetStaffMembersForCurrentPage());
};
export const onRegisterStaffMember = createAction(
    'FETCH_REGISTER_STAFF_MEMBER',
    (data) => Api.registerStaff(data),
    () => ({
        apiCall: true,
        onSuccess: onRegisterStaffMemberSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onChangeAnchorSuccess = () => dispatch => {
    dispatch(resetSubmitFormData());
    dispatch(hideModal());
    dispatch(fetchGetSubRoles());
};
export const onChangeAnchor = createAction(
    'FETCH_CHANGE_ANCHOR',
    (data) => Api.changeAnchor(data),
    () => ({
        apiCall: true,
        onSuccess: onChangeAnchorSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchChangeAnchor = (data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onChangeAnchor(data));
};

export const fetchRemoveStaffMember = (staffMemberId) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onRemoveStaffMember(staffMemberId));
};
export const onRemoveStaffMemberSuccess = () => dispatch => {
    dispatch(resetSubmitFormData());
    dispatch(hideModal());
    dispatch(onGetStaffMembersForCurrentPage());
};
export const onRemoveStaffMember = createAction(
    'FETCH_REMOVE_STAFF_MEMBER',
    (staffMemberId) => Api.removeStaffMember(staffMemberId),
    () => ({
        apiCall: true,
        onSuccess: onRemoveStaffMemberSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const setStaffMemberToRemove = createAction('STAFF_MEMBER_TO_REMOVE_SET', staffMemberId => staffMemberId);

export const removeStaffMember = () => (dispatch, getState) => {
    dispatch(fetchRemoveStaffMember(getStaffMemberToRemoveId(getState())));
    //dispatch(setStaffMemberToRemove(null));
};

//- State
const initialState = {
    fetching: false,
    data: null,
    allStaffMembersData: null,
    allStaffMembersFetching: null,
    error: null,
    staffMemberToRemoveId: null,
    currentPage: null,
    totalPages: null
};

//- Reducers
export default handleActions({
    FETCH_GET_STAFF_MEMBERS: (state) => {
        return { ...state, data: null, currentPage: null, totalPages: null, error: null, fetching: true };
    },
    FETCH_GET_STAFF_MEMBERS_FAILED: (state, action) => {
        return { ...state, data: null, currentPage: null, totalPages: null, error: action.payload, fetching: false };
    },
    FETCH_GET_STAFF_MEMBERS_SUCCESS: (state, action) => {
        return { ...state, data: action.payload.content, currentPage: action.payload.number, totalPages: action.payload.totalPages, error: null, fetching: false };
    },
    STAFF_MEMBER_TO_REMOVE_SET: (state, action) => {
        return { ...state, staffMemberToRemoveId: action.payload };
    },
    FETCH_GET_ALL_STAFF_MEMBERS: (state) => {
        return { ...state, allStaffMembersData: null, allStaffMembersFetching: true };
    },
    FETCH_GET_ALL_STAFF_MEMBERS_FAILED: (state) => {
        return { ...state, allStaffMembersData: null, allStaffMembersFetching: false };
    },
    FETCH_GET_ALL_STAFF_MEMBERS_SUCCESS: (state, action) => {
        return { ...state, allStaffMembersData: action.payload.content, allStaffMembersFetching: false };
    }
}, initialState);

//- Selectors
export const getStaffMembers = state => state.staffMembers;

export const loadingStaffMembers = state => getStaffMembers(state).fetching;

export const getCurrentPageForStaff = state => getStaffMembers(state).currentPage;

export const getTotalPagesForStaff = state => getStaffMembers(state).totalPages;

export const getActiveStaffMembers = state => _.filter(getStaffMembersData(state), member => member.active);

export const getAllStaffMembersData = state => {
    if (_.isNil(getStaffMembers(state).allStaffMembersData)) {
        return null;
    }

    return _.map(getStaffMembers(state).allStaffMembersData, member => ({
        id: member.id,
        firstName: member.identityAlias.firstName,
        lastName: member.identityAlias.lastName,
        email: member.email,
        active: member.active
        })
    );
};

export const getAllActiveStaffMembers = state => _.filter(getAllStaffMembersData(state), member => member.active);

export const getStaffMembersData = state => {
    if (_.isNil(getStaffMembers(state).data)) {
        return null;
    }

    return _.map(getStaffMembers(state).data, member => ({
        id: member.id,
        firstName: member.identityAlias.firstName,
        lastName: member.identityAlias.lastName,
        email: member.email,
        active: member.active
    })
    );
};

export const getStaffMemberToRemoveId = state => getStaffMembers(state).staffMemberToRemoveId;

export const getStaffMemberToRemove = state => {
    return _.find(getStaffMembersData(state), member => member.id === getStaffMemberToRemoveId(state));
};

export const getStaffMemberToRemoveName = state => {
    let staffMemberToRemove = getStaffMemberToRemove(state);

    if (_.isNil(staffMemberToRemove)) {
        return null;
    }

    return _.isNil(staffMemberToRemove.firstName) || _.isNil(staffMemberToRemove.lastName) ? staffMemberToRemove.email :
        (staffMemberToRemove.firstName + " " + staffMemberToRemove.lastName);
};

export const getAvailableStaffMembersForChangeAnchor = state => {
    let activeMembers = getAllActiveStaffMembers(state);
    let anchorId = getUserId(state);

    return activeMembers.filter((member) => member.id !== anchorId);
}



// WEBPACK FOOTER //
// ./src/reducers/organization/staffMembers.js